module.exports = __webpack_public_path__ + "img/SketchPng3bd4c81d3702978f30ea96a9fe7fd7215a59baf9b1b21e77315138b078ba77fb.a8a02c0c.png";